<template>
  <b-modal title="Detalhes do Teste" v-model="show" size="xl">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="6">
          <b-form-group label="Teste:" label-for="teste" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="teste" v-model="template.teste" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Duração:" label-for="duracao" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="duracao" v-model="template.duracao" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Local:" label-for="local" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="local" v-model="template.local" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Resultado:" label-for="resultado" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="resultado" v-model="template.resultado" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Procedimento:" label-for="procedimento" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.procedimento">
              <b-form-select-option v-for="documento of getDocumentos" v-bind:key="documento.id" :value="documento.numero"
                >{{ documento.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Instrumento:" label-for="instrumento" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.instrumento">
              <b-form-select-option v-for="instrumento of getInstrumentos" v-bind:key="instrumento.id" :value="instrumento"
                >{{ instrumento.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Unidade:" label-for="unidade" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="unidade" v-model="template.unidade" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Responsável:" label-for="responsavel" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.inspetor">
              <b-form-select-option v-for="profissional of getProfissionais" v-bind:key="profissional.id" :value="profissional"
                >{{ profissional.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-group label-cols-sm="2" label="Observação:" label-align-sm="center">
            <b-form-textarea v-model="template.observacao" rows="6"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useClienteStore } from "@/stores/ClienteStore";
import { useDocumentoStore } from "@/stores/DocumentoStore";
import { useInstrumentoStore } from "@/stores/InstrumentoStore";
import { useProfissionalStore } from "@/stores/ProfissionalStore";
import { storeToRefs } from "pinia";
import Files from "@/http/files";
import Teste from "@/models_reports/Teste";

export default {
  name: "ModalDeTemplateTE",

  components: {},

  data() {
    return {
      show: false,
      files: new Files(this.$http),
      template: new Teste(),
      arquivo: null,
    };
  },

  watch: {
    arquivo: function (newValue) {
      this.$emit("loadImagemExtra", newValue);
    },
  },

  methods: {
    call(teste) {
      this.show = !this.show;
      this.template = teste;
    },
  },

  setup() {
    const store = useSgcqStore();
    const clienteStore = useClienteStore();
    const documentoStore = useDocumentoStore();
    const { getDocumentos } = storeToRefs(documentoStore);
    const instrumentoStore = useInstrumentoStore();
    const { getInstrumentos } = storeToRefs(instrumentoStore);
    const profissionalStore = useProfissionalStore();
    const { getProfissionais } = storeToRefs(profissionalStore);

    return {
      store,
      clienteStore,
      documentoStore,
      getDocumentos,
      instrumentoStore,
      getInstrumentos,
      profissionalStore,
      getProfissionais,
    };
  },
};
</script>

<style lang="scss" scoped></style>
